<!-- ■ ご注意 ■ -->
<template>
  <div class="column">
    <h2 class="column-title">■ ご注意 ■</h2>

    <br />
    <div class="common-caution">
      ※{{
        is0yenTicket ? "チケット取得" : "お支払い完了"
      }}後、ログイン後の「使う」タブにチケットを表示します。<br /><br />
      <template v-if="!is0yenTicket">
        ※購入後のキャンセル・払戻等の条件については、チケットの<a
          class="terms-link"
          @click="goToExternalLink(ticketTermsUrl)"
          >利用規約</a
        >をご覧ください。払戻が可能な場合は、ログイン後のチケット詳細画面から払戻ができます（所定の手数料が生じる場合があります）。ご不明な点はEMotサポートセンターにお問い合わせください。
      </template>
    </div>
    <!-- bookGroup.reserved_limited_atの表示 -->
    <div v-if="limitedAt" class="reserved-limited-at">
      上記チケットはまだ購入が確定していません。<br />
      {{
        displayReservedLimitedAt(limitedAt)
      }}までに購入の処理を確定させてください。
    </div>
    <!-- masterBook.content.description_json.MbBeforePurchaseCautionの表示 -->
    <div
      v-if="note"
      class="column-body"
      style="font-size: 14px; white-space: pre-wrap"
      v-html="newlineConvert(note)"
    />
    <div
      v-if="!is0yenTicket"
      class="column-body"
      style="font-size: 14px; white-space: pre-wrap"
    >
      <p>
        <strong style="color: red"
          >※必ず次に開く画面で決済を行ってください。</strong
        >
      </p>
      <p>
        <strong style="color: red"
          >決済が完了するまでブラウザの「戻る」ボタンを押さないでください。
        </strong>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MbBeforePurchaseCaution",
  props: {
    limitedAt: {
      type: String,
      required: false,
      default: null,
    },
    note: {
      type: String,
      required: false,
      default: null,
    },
    ticketTermsUrl: {
      type: String,
      required: true,
    },
    is0yenTicket: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  margin-top: 15px;
  margin-bottom: 30px;
  align-items: start;

  .column-title {
    margin: 18px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
    color: #000000;
  }

  .column-title p {
    margin: 5px 0 25px;
    font-size: 15px;
    line-height: 24px;
    color: black;
    font-weight: 100;
  }

  .common-caution {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;

    .terms-link {
      color: blue;
      text-decoration: underline;
    }
  }

  .reserved-limited-at {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
  }

  .column-body {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
    white-space: pre-line;
    line-height: 1.5rem;
    margin-bottom: 10px;
  }
}
</style>
